export var StandardFormTestSubjects;
(function (StandardFormTestSubjects) {
    StandardFormTestSubjects["StandardFormCancelButton"] = "cancelForm";
    StandardFormTestSubjects["StandardFormSubmitButton"] = "submitForm";
    StandardFormTestSubjects["StandardFormNameInput"] = "StandardFormNameInput";
})(StandardFormTestSubjects || (StandardFormTestSubjects = {}));
//# sourceMappingURL=standard-form.enum.js.map